import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["loader"]
    static values = {frameId: String}

    connect() {
        // Initialize - ensure loader is hidden initially
        if (this.hasLoaderTarget) {
            this.loaderTarget.classList.add("hidden")
        }

        // Listen for turbo:frame-render event
        document.addEventListener("turbo:frame-render", this.hideLoader.bind(this))
    }

    disconnect() {
        // Clean up event listeners when controller is disconnected
        document.removeEventListener("turbo:frame-render", this.hideLoader.bind(this))
    }

    // This is called when a link is clicked
    showLoader(event) {
        // Get the frame ID from the link's data-turbo-frame attribute
        const frameId = event.currentTarget.getAttribute("data-turbo-frame")
        if (frameId) {
            this.frameIdValue = frameId
        }

        // Show the loading spinner
        if (this.hasLoaderTarget) {
            this.loaderTarget.classList.remove("hidden")
        }
    }

    // Hide the loader when frame content is rendered
    hideLoader(event) {
        // Only hide the loader if the rendered frame is the one we're watching
        if (this.hasFrameIdValue && event.target.id === this.frameIdValue) {
            if (this.hasLoaderTarget) {
                this.loaderTarget.classList.add("hidden")
            }
        }
    }
}
